import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{
      display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
      minHeight:'60vh', textAlign:'center', padding:'40px 24px'
    }}>
      <div style={{fontSize:'6rem',lineHeight:1,marginBottom:24,opacity:0.15,fontWeight:900,color:'var(--primary)'}}>404</div>
      <h1 style={{fontSize:'1.5rem',fontWeight:700,marginBottom:12}}>页面不存在</h1>
      <p style={{color:'var(--text-secondary)',marginBottom:32}}>您访问的页面不存在或已被移除，请检查链接地址。</p>
      <Link to="/" className="btn btn-primary">返回首页</Link>
    </div>
  );
}
